<script lang="ts">
  import PayoutDetail from '../../components/charity/payout/detail.svelte';
  
  // Get payout ID from route params
  export let params: { id: string };
</script>

<PayoutDetail {params} /> 